// Example: Dashboard.jsx
import React from "react";
const Dashboard = () => {
  return <div className="p-8 text-xl">Welcome to Dashboard</div>;
};
export default Dashboard;
